import { render, staticRenderFns } from "./messageSetting.vue?vue&type=template&id=0d466476"
import script from "./messageSetting.vue?vue&type=script&lang=js"
export * from "./messageSetting.vue?vue&type=script&lang=js"
import style0 from "./messageSetting.vue?vue&type=style&index=0&id=0d466476&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports